import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { saveRuleFn, outListFn } from 'api/approval/config';
import Org from '@/components/organization/index.vue';
export default {
  components: {
    Org: Org
  },
  data: function data() {
    return {
      form: {
        staff_list: [],
        department_list: []
      },
      visible: false,
      dataForm: {},
      arr: [],
      disabled: false,
      disabledForm: true,
      currrntIndex: null
    };
  },
  mounted: function mounted() {
    this.getAll();
  },
  methods: {
    getAll: function getAll() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return outListFn();
            case 2:
              res = _context.sent;
              _this.$emit('clear-loading');
              _this.arr = res.data.map(function (item) {
                item.isEdit = false;
                item.loading = false;
                item.rest_time_rule = item.rest_time_rule || [{
                  over_time: '',
                  rest_time: ''
                }];
                item.is_rest_time_rule = Boolean(item.rest_time_rule_text.length);
                return item;
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handlerSelected: function handlerSelected(params) {
      var current = this.arr[this.currrntIndex];
      current.staff_ids = params.staffIds;
      current.department_ids = params.depIds;
      current.num = params.staffCount;
      this.form.department_list = params.dept_list;
      this.form.staff_list = params.staff_list;
    },
    openSel: function openSel(index) {
      this.visible = true;
      this.currrntIndex = index;
    },
    dataFormSubmit: function dataFormSubmit(item) {
      var _this2 = this;
      item.loading = true;
      saveRuleFn(item).then(function () {
        return _this2.getAll();
      }).finally(function () {
        return item.loading = false;
      });
    },
    clearHandle: function clearHandle(item, status) {
      item.isEdit = status || false;
      if (!status) this.getAll();
    },
    over_time_input: function over_time_input(time) {
      time.over_time = time.over_time.replace(/^\D*(\d*(?:\.\d{0,1})?).*$/g, '$1');
      ['0', '0.'].includes(time.over_time) && (time.over_time = '');
      time.over_time > 24 && (time.over_time = 24);
    },
    rest_time_input: function rest_time_input(time) {
      time.rest_time = time.rest_time.replace(/^\D*(\d*(?:\.\d{0,1})?).*$/g, '$1');
      ['0', '0.'].includes(time.rest_time) && (time.rest_time = '');
      time.rest_time > 24 && (time.rest_time = 24);
    }
  }
};